<template>
  <div class="vlog">
    <div class="vlogbg">
      <appHeader activeIndex="vlog" ></appHeader>
      <div class="vlogContent">
        <!-- 介绍 -->
        <div class="vlogInfo">
          <div class="vlogInfo1">
            <img class="vlogInfo1Img1" src="../../assets/img/Product/vlog.png"  alt />
            <br>
            <img class="vlogInfo1Img2"  src="../../assets/img/products/vlog/vlogQRcode.png" alt />
            <div>扫描二维码下载</div>  
          </div>
          <div class="vlogInfo2">
            <img src="../../assets/img/products/vlog/vlogFont.png" alt />
             <el-divider></el-divider>
             <h2>应用介绍</h2>
             <p>Vlog剪辑卡点：</p>
             <p>想要拥有一款既可以剪辑视频，又可以拼接视频的APP吗？关键是还能本地播放短视频？那么本款《Vlog剪辑卡点》来了！它既可以帮你剪辑视频，还能进行视频拼接，剪辑或者拼接完成，在作品库就可以查看哦！</p>
          </div>
          <div style="clear: both;"></div> 
        </div>
        <!-- 下部分内容 -->
        <div class="vlogCarousel">
          <img src="../../assets/img/products/vlog/carousel.png" alt />
        </div>
      </div>
    </div>
    <appFooter></appFooter>

  </div>
</template>
 
<script>
import appHeader from "../components/Header";
import appFooter from "../components/Footer";
export default {
  name: "Huoguo",
  components: {
    appHeader,appFooter
  },
  data() {
    return {
      nowLeft: 0
    };
  },
  mounted() {},
  methods: {
    
      left() {
        if(this.nowLeft <= -40){
          return;
        }
        this.nowLeft = this.nowLeft -20
      },

      right() {
        if(this.nowLeft >= 0){
          return;
        }
        this.nowLeft = this.nowLeft +20
      }
  }
};
</script>
<style>
@import "../../assets/css/products/vlog.css";
</style>
